import axios from 'axios'
import md5 from 'js-md5'

function isObject(obj) {
  if (Object.prototype.toString.call(obj).toLocaleLowerCase() === '[object object]') {
    return true
  }
  return false
}

// 根据本地存储的语言偏好，映射 Accept-Language
function getAcceptLanguage() {
  try {
    const locale = localStorage.getItem('APP_LOCALE')
    if (locale === 'zh-CN' || locale === 'en-US') return locale
  } catch (e) {
    // ignore
  }
  return 'zh-CN'
}

const service = axios.create({
  baseURL: '/',
  timeout: 10000, // request timeout
  headers: {
    'Content-Type': 'application/json',
  }
})

service.interceptors.request.use(config => {
  // 根据当前语言偏好，给请求加 Accept-Language（用于后端返回对应语言文案）
  config.headers = config.headers || {}
  config.headers['Accept-Language'] = getAcceptLanguage()

  // 签名参数
  const SIGN_KEY = 'eWnIx3SCTRopyYi2'
  const timestamp = Math.floor(Date.now() / 1000)
  const sign = md5(SIGN_KEY + timestamp).toString()
  
  // 如果是POST请求且有data，添加签名参数
  if (config.method === 'post' && config.data) {
    if (typeof config.data === 'string') {
      // 如果data是字符串，先解析
      try {
        const dataObj = JSON.parse(config.data)
        dataObj.time = timestamp
        dataObj.sign = sign
        config.data = JSON.stringify(dataObj)
      } catch (e) {
        // 如果解析失败，说明data已经是处理过的对象
      }
    } else {
      // 如果data是对象
      config.data.time = timestamp
      config.data.sign = sign
    }
  }

  return config
  
}, error => {
  console.log(error)
  Promise.reject(error)
})

service.interceptors.response.use(
  response => {

    if(!isObject(response.data)) {
      return Promise.reject(response.data)
    }

    return response.data
  },
  error => {
    return Promise.reject(error)
  })

export default service